import { createActions } from 'redux-actions';

const {
	setAllComponentsLocked,
	setComponentLockAlertVisibility,
    setPageWideSelectedReading,
    clearPageWideSelectedReading,
} = createActions({
	SET_ALL_COMPONENTS_LOCKED: locked => ({ locked }),
	SET_COMPONENT_LOCK_ALERT_VISIBILITY: show => ({ show }),
    SET_PAGE_WIDE_SELECTED_READING: (survey, reading) => ({ survey, reading }),
    CLEAR_PAGE_WIDE_SELECTED_READING: () => ({}),
});

export { 
	setAllComponentsLocked, 
	setComponentLockAlertVisibility, 
	setPageWideSelectedReading, 
	clearPageWideSelectedReading 
};
